import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchSchemes(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('reservation/entitlement-schemes', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteScheme(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`reservation/entitlement-schemes/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
